import AOS from 'aos';
/*import {
	Fancybox,
	Carousel,
	Panzoom
} from "@fancyapps/ui"; */
import {
	Fancybox
} from "@fancyapps/ui";
import StickySidebar from 'sticky-sidebar';
import Sticky from 'sticky-js';
var sticky = new Sticky('[data-sticky]', {});

import Swiper from 'swiper/bundle';
exports.swiper = Swiper;

AOS.init({
	once: true,
	duration: 800, // values from 0 to 3000, with step 50ms
	easing: 'ease-in-out',
	initClassName: false,
	offset: 200,
	anchorPlacement: 'top-bottom',
});

Fancybox.bind("[data-fancybox]", {
	hideScrollbar: true,
});

jQuery(function ($) {

	$(window).scroll(function () {
		if ($(this).scrollTop() > 100 && !($('body').hasClass('footer-visible'))) {
			$('#scrollToTopBtn').fadeIn();
		} else {
			$('#scrollToTopBtn').fadeOut();
		}
	});

	$(document).on('click', '#scrollToTopBtn', scrollToTop);

	function scrollToTop() {
		$('html, body').animate({ scrollTop: 0 }, 800);
	}


	$(document).on('change', 'input[name="category"]', function () {
		$(this).closest('form').trigger('submit');
	})

	$('#filter-form').on('submit', function (event) {
		event.preventDefault();
		var formData = $(this).serialize();

		$.ajax({
			url: mintAjax.ajaxurl, // The WordPress AJAX handler
			data: formData,
			dataType: 'json',
			type: 'POST',
			beforeSend: function () {
				$('#mint_posts_wrap').addClass('loading');
			},
			success: function (data) {
				// when filter applied:
				// set the current page to 1
				mintAjax.current_page = 1;

				// set the new query parameters
				mintAjax.posts = data.posts;

				// set the new max page parameter
				mintAjax.max_page = data.max_page;



				$('#mint_posts_wrap').removeClass('loading').html(data.content);
				// hide load more button, if there are not enough posts for the second page
				if (data.max_page < 2) {
					$('#mint_loadmore').hide();
				} else {
					$('#mint_loadmore').show();
				}
			},
			error: function (xhr, status, error) {
				$('#mint_posts_wrap').html('<p>Error occurred. Please try again later.</p>');
				console.log(xhr.responseText);
			}
		});
	});

	/*
	 * Load More
	 */
	$('#mint_loadmore').click(function () {

		$.ajax({
			url: mintAjax.ajaxurl, // AJAX handler
			data: {
				'action': 'loadmorebutton', // the parameter for admin-ajax.php
				'query': mintAjax.posts, // loop parameters passed by wp_localize_script()
				'page': mintAjax.current_page // current page
			},
			type: 'POST',
			beforeSend: function (xhr) {
				$('#mint_loadmore').text('Loading...'); // some type of preloader
			},
			success: function (posts) {
				if (posts) {
					//console.log(posts);
					$('#mint_loadmore').text('More posts');
					$('#mint_posts_wrap').append(posts); // insert new posts
					mintAjax.current_page++;

					if (mintAjax.current_page == mintAjax.max_page)
						$('#mint_loadmore').hide(); // if last page, HIDE the button

				} else {
					$('#mint_loadmore').hide(); // if no data, HIDE the button as well
				}
			}
		});
		return false;
	});

	if (!$('body').hasClass('page-id-17')) {
		// Determine the target class based on window width
		
	
		// Select all elements with the target class
		var targets = document.querySelectorAll('.mini-quote-ul');
	
		// Loop through each target element
		targets.forEach(function(target) {
			// Create a MutationObserver for the current target
			var observer = new MutationObserver(function (mutations) {
				mutations.forEach(function (mutation) {
					var targetEl = $(window).width() > 768 ? '.mini-quote-ul-desktop' : '.mini-quote-ul-mobile';
					$(targetEl).addClass('open');
					console.log('Opened ' + targetEl);
				});
			});
	
			// Configuration of the observer
			var config = {
				childList: true,
				subtree: true
			};
			
			// Start observing the current target
			observer.observe(target, config);
		});
	
		// Event listener for closing the quote
		$(document).on('click', '#quote-page-overlay', function (event) {
			$('.mini-quote-ul').removeClass('open');
			$('.mint-mini-quote-dropdown').hide();
			console.log('Closed');
		});
	}
	

	$(document).on('change', 'table.addify-quote-form__contents input[type="number"]', function (event) {
		$('#afrfq_update_quote_btn').prop('disabled', false);
	});


	var leaveTimeouts = {};

	$(document).on('mouseenter', '.mint-product-archive-colour', function (e) {
		e.preventDefault();
		var productElement = $(this).closest('.product'),
			productImg = productElement.find('.mint-product-loop-image');
		clearTimeout(leaveTimeouts[productElement.attr('id')]); // Clear any previous setTimeout for mouseleave

		var new_image = productImg.data('original');
		if ($(this).data('img').length > 0) {
			new_image = $(this).data('img');
		}

		productImg.attr("src", new_image).attr("srcset", new_image);
	});

	$(document).on('mouseleave', '.mint-product-archive-colour', function (e) {
		e.preventDefault();
		var productElement = $(this).closest('.product'),
			productImg = productElement.find('.mint-product-loop-image');

		var new_image = productImg.data('original');

		// Set a delay for mouseleave
		leaveTimeouts[productElement.attr('id')] = setTimeout(function () {
			productImg.attr("src", new_image).attr("srcset", new_image);
		}, 1500);
	});

	// Unbind mouseleave if mouseenter occurs within the product
	$(document).on('mouseenter', '.product', function (e) {
		e.preventDefault();
		var productElement = $(this);
		clearTimeout(leaveTimeouts[productElement.attr('id')]); // Clear the setTimeout for mouseleave
	});

	$(document).on('change', '.mint-product-archive-colour', function (e) {
		$(this).closest('form').trigger('submit');
	})

	$(document).on('mouseenter', '.mint-product-loop-image', function (e) {
		if ($(this).data('hover').length > 0) {
			var new_image = $(this).data('hover');
			$(this).attr("src", new_image).attr("srcset", new_image).addClass('img-hover');
		}
	});

	$(document).on('mouseleave', '.mint-product-loop-image', function (e) {
		if ($(this).hasClass('img-hover')) {
			var new_image = $(this).data('original');
			$(this).attr("src", new_image).attr("srcset", new_image).removeClass('img-hover');
		}
	});


	if (document.querySelector('#mint-products-filter')) {
		var sidebar = new StickySidebar('#mint-products-filter', {
			containerSelector: '#mint-products-archive',
			innerWrapperSelector: '#mint-products-filter-wrapper',
			topSpacing: 150,
			bottomSpacing: 20,
			minWidth: 991
		});
		let resizeTimer;
		const resizeObserver = new ResizeObserver(entries => {
			clearTimeout(resizeTimer);

			// Set a new timeout
			resizeTimer = setTimeout(() => {
				sidebar.updateSticky();
			}, 1000);
		});

		// Start observing a DOM node
		resizeObserver.observe(document.querySelector('#mint-products-filter-inner'));
	}

	var thumbs_swiper = new mint.swiper("#mint-product-image-gallery-thumbs", {
		loop: true,
		spaceBetween: 10,
		slidesPerView: 4,
		freeMode: true,
		watchSlidesProgress: true,
	});
	var main_swiper = new mint.swiper("#mint-product-image-gallery", {
		loop: true,
		spaceBetween: 10,
		/*navigation: {
		  nextEl: ".swiper-button-next",
		  prevEl: ".swiper-button-prev",
		},*/
		thumbs: {
			swiper: thumbs_swiper,
		},
	});
	// Listen for the 'found_variation' event
	$(document).on('found_variation', 'form.cart', function(event, variation) {
		var variationImages = variation.mint_gallery;
		updateSwiperGallery(main_swiper, variationImages);
		updateSwiperGallery(thumbs_swiper, variationImages);
	});
	// Function to update the Swiper gallery with new images
	function updateSwiperGallery(swiper, images) {
		swiper.removeAllSlides();
		for (var i = 0; i<images.length; i++) {
			swiper.appendSlide('<div class="swiper-slide rounded-1 border overflow-hidden"><img src="' + images[i] + '" alt=""></div>');
		}
	}
	// Replace this function with your logic to get variation images
	function getVariationImages(variation) {
		//return variation.image_gallery ? variation.image_gallery.split(',') : [];
		var imageUrls = [];
		var maxIndex = 10;
		for (var i = 0; i <= maxIndex; i++) {
			var variableName = 'fifu_image_url_' + i;
			// Check if the variable is defined
			if (variation.variableName) {
				// Add the value to the array
				imageUrls.push(variation.variableName);
			}
			return imageUrls;
		}
	}

	var portfolio_swiper = new mint.swiper('#portfolio-slider', {
			slidesPerView: 'auto',
			loop: true,
		});	
		console.log(portfolio_swiper);



}); //jQuery

document.addEventListener("DOMContentLoaded", function () {

	// Get the header element
	const header = document.querySelector("#wrapper-navbar");
	const toggleClass = "sticky";

	window.addEventListener("scroll", () => {
		if (window.scrollY > 1) {
			header.classList.add('sticky');
		} else {
			header.classList.remove('sticky');
		}
	});

	if (document.querySelector('#mint-products-filter')) {
		var sidebar = new StickySidebar('#mint-products-filter', {
			containerSelector: '#mint-products-archive',
			innerWrapperSelector: '#mint-products-filter-wrapper',
			topSpacing: 150,
			bottomSpacing: 20,
			minWidth: 991
		});
		let resizeTimer;
		const resizeObserver = new ResizeObserver(entries => {
			clearTimeout(resizeTimer);

			// Set a new timeout
			resizeTimer = setTimeout(() => {
				sidebar.updateSticky();
			}, 1000);
		});

		// Start observing a DOM node
		resizeObserver.observe(document.querySelector('#mint-products-filter-inner'));
	}

	function handleIntersection(entries) {
		let isInViewport = false;

		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				isInViewport = true;
			}
		});

		if (isInViewport) {
			document.body.classList.add('footer-visible');
		} else {
			document.body.classList.remove('footer-visible');
		}
	}

	if (document.querySelector('#scrollToTopBtn')) {
		const targetElement = document.querySelector('#wrapper-footer');
		const observer = new IntersectionObserver(handleIntersection);
		observer.observe(targetElement);
	}

});